import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';

import './assets/css/secondary/style.css';
import './assets/css/style.css';
import './assets/css/style-core.css';
import './assets/css/custom.css';
import './assets/css/hotale-style-custom.css';
import './assets/css/tourmaster-global-style-custom.css';
import './assets/css/tourmaster-room-style-custom.css';
import './assets/js/plugins/goodlayers-core/include/css/page-builder.css';


import Home from './pages/Home';
import Room from './pages/Room';
import Kingroomin from './pages/Kingroomin';
import Kingroomout from './pages/Kingroomout';
import Family from './pages/Family';
import Dormitory from './pages/Dormitory';
import Gallery from './pages/Gallery';
import Offers from './pages/Offers';
import Aboutus from './pages/Aboutus';
import Contactus from './pages/Contactus';

function App() {

  return (
    <Router>
      <div>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/bbmirissa/room" element={<Room />} />
        <Route path="/bbmirissa/room/kingroomwithindoorbath" element={<Kingroomin />} />
        <Route path="/bbmirissa/room/kingroomwithoutdoorbath" element={<Kingroomout />} />
        <Route path="/bbmirissa/room/familyroom" element={<Family />} />
        <Route path="/bbmirissa/room/dormitoryroom" element={<Dormitory />} />
        <Route path="/bbmirissa/gallery" element={<Gallery />} />
        <Route path="/bbmirissa/offers" element={<Offers />} />
        <Route path="/bbmirissa/about" element={<Aboutus />} />
        <Route path="/bbmirissa/contactus" element={<Contactus />} />

        </Routes>
      </div>
    </Router>
  );
}

export default App;
